import { createContext, useContext } from "react";
import type { QuoteWizardContext as QuoteWizardContextType } from "./useQuoteWizard";

export const QuoteWizardContext = createContext<QuoteWizardContextType | null>(null);

export function useQuoteWizardContext() {
  const context = useContext(QuoteWizardContext);
  if (!context) {
    throw new Error("useQuoteWizardContext must be used within a QuoteWizardProvider");
  }
  return context;
}
